module.exports = __webpack_public_path__ + "img/message-square.f1ae2a4a.svg";